import './RoboApp.css';
import RoboBackground from '../Components/roboBackground';
import RoboLogo from '../Components/robologo';
import Box from '../Components/box';
import ButtonBar from '../Components/buttonBar';
import blood from '../Assets/blood.png'
import React from 'react';
import { Outlet } from 'react-router-dom';


function App({mainBoxHeight, mainBoxWidth, borderWidth, windowX, windowY}) {

  React.useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = '/favicon2.ico';
  }, []);

  return (
    <div className="RoboApp">
      <div style={{position: 'absolute', overflow:'hidden', zIndex: "-1"}}>
        <RoboBackground screenX={Math.max(windowX,mainBoxWidth+borderWidth)} screenY={mainBoxHeight+260}/>
      </div>
      <div>
        <RoboLogo/>
        <Box color="#00FF00" height={mainBoxHeight} width={mainBoxWidth} corner={0} style={{position:"absolute", top:220, left:Math.max(0,(windowX-mainBoxWidth)/2), margin:"0 auto"}}>
        
          <ButtonBar width={mainBoxWidth-60} height={80} cornerSize={0} fudgeWidth2={-10} buttons={[
            {text: "About", href:"/robotron/"},
            {text: "Download", href:"/robotron/download", minWidth:190},
            {text: "Game", href:"/robotron/game"},
            {text: "Highscores", href:"/robotron/highscores", minWidth:210}
          ]} />
          <Outlet/>
        </Box>
      </div>
 

        


      
    </div>
  );
}

export default App;
